"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checklistMaxNumItems = exports.checklistItemMaxLength = void 0;
exports.checklistItemMaxLength = 3000;
exports.checklistMaxNumItems = 200;
